import { put, select } from "redux-saga/effects";

import { searchKnowledgeData, searchPublications, searchTopic, searchVideos } from "domains/search/actions";
import type { UpdateSearchQueryAction } from "domains/search/actionTypes";
import {
  getIsInteractiveDataSearchCached,
  getIsPublicationsSearchCached,
  getIsTopicsSearchCached,
  getIsVideosSearchCached,
  getSearchSectionVisibility,
} from "domains/search/selectors";
import { getCanSeeSectionContent } from "entities/permissions/selectors";

export function* triggerSearchesOnTypingSaga({ meta }: UpdateSearchQueryAction) {
  if (!meta.query) {
    return;
  }
  const searchVisibility: ReturnType<typeof getSearchSectionVisibility> = yield select(getSearchSectionVisibility);
  const isTopicSearchCached: ReturnType<typeof getIsTopicsSearchCached> = yield select(getIsTopicsSearchCached);
  const isPublicationsSearchCached: ReturnType<typeof getIsPublicationsSearchCached> =
    yield select(getIsPublicationsSearchCached);
  const isVideosSearchCached: ReturnType<typeof getIsVideosSearchCached> = yield select(getIsVideosSearchCached);
  const isInteractiveDataSearchCached: ReturnType<typeof getIsInteractiveDataSearchCached> = yield select(
    getIsInteractiveDataSearchCached,
  );
  const accessToTabContent: ReturnType<typeof getCanSeeSectionContent> = yield select(getCanSeeSectionContent);

  const { type, query } = meta;
  if ((!isTopicSearchCached && searchVisibility.topics && !type) || type === "topics") {
    yield put(searchTopic({ query }));
  }
  if (
    (!isPublicationsSearchCached && searchVisibility.publications && accessToTabContent && !type) ||
    type === "publications"
  ) {
    yield put(searchPublications({ query }));
  }
  if ((!isVideosSearchCached && searchVisibility.videos && accessToTabContent && !type) || type === "videos") {
    yield put(searchVideos({ query }));
  }
  if (
    (!isInteractiveDataSearchCached && searchVisibility.interactiveData && accessToTabContent && !type) ||
    type === "interactiveData"
  ) {
    yield put(searchKnowledgeData({ query }));
  }
}
